import { defineStore } from 'pinia';
import type { IGtmPush } from '~/types/gtm';

export const useStoreGtm = defineStore('abstractGtm', {
  state: () => ({
    enabled: false,
  }),
  actions: {
    push(data: IGtmPush) {
      if (this.enabled) {
        return useGtm()?.push({ event: 'tEvent', ...data });
      }
    },
    enable() {
      this.enabled = true;
      return useGtm()?.enable(true);
    },
  },
});
